export const catergory = [
    { label: "ALL", value: null },
    { label: "OC", value: "oc" },
    { label: "BC ", value: "bc" },
    { label: "BCM ", value: "bcm", },
    { label: "MBC ", value: "mbc", },
    { label: "SC ", value: "sc", },
    { label: "SCA ", value: "sca", },
    { label: "ST ", value: "st", },
    { label: "MBCDNC ", value: "mbcdnc", },
    { label: "MBCV ", value: "mbcv", },
  ];
 export const district = [
    { label: "Ariyalur", value: "Ariyalur" },
    { label: "Chengalpattu", value: "Chengalpattu" },
    { label: "Chennai", value: "Chennai" },
    { label: "Coimbatore", value: "Coimbatore" },
    { label: "Cuddalore", value: "Cuddalore" },
    { label: "Dharmapuri", value: "Dharmapuri" },
    { label: "Dindigul", value: "Dindigul" },
    { label: "Erode", value: "Erode" },
    { label: "Kallakurichi", value: "Kallakurichi" },
    { label: "Kancheepuram", value: "Kancheepuram" },
    { label: "Kanyakumari", value: "Kanyakumari" },
    { label: "Karur", value: "Karur" },
    { label: "Krishnagiri", value: "Krishnagiri" },
    { label: "Madurai", value: "Madurai" },
    { label: "Mayiladuthurai", value: "Mayiladuthurai" },
    { label: "Nagapattinam", value: "Nagapattinam" },
    { label: "Namakkal", value: "Namakkal" },
    { label: "Nilagiri", value: "Nilagiri" },
    { label: "Perambalur", value: "Perambalur" },
    { label: "Pudukkottai", value: "Pudukkottai" },
    { label: "Ramanathapuram", value: "Ramanathapuram" },
    { label: "Ranipet", value: "Ranipet" },
    { label: "Salem", value: "Salem" },
    { label: "Sivagangai", value: "Sivagangai" },
    { label: "Tenkasi", value: "Tenkasi" },
    { label: "Thanjavur", value: "Thanjavur" },
    { label: "Theni", value: "Theni" },
    { label: "Thiruchirappalli", value: "Thiruchirappalli" },
    { label: "Thiruppathur", value: "Thiruppathur" },
    { label: "Thiruvallur", value: "Thiruvallur" },
    { label: "Thiruvannamalai", value: "Thiruvannamalai" },
    { label: "Thiruvarur", value: "Thiruvarur" },
    { label: "Thoothukudi", value: "Thoothukudi" },
    { label: "Tiruchirappalli", value: "Tiruchirappalli" },
    { label: "Tirunelveli", value: "Tirunelveli" },
    { label: "Tiruppur", value: "Tiruppur" },
    { label: "Vellore", value: "Vellore" },
    { label: "Villupuram", value: "Villupuram" },
    { label: "Virudhunagar", value: "Virudhunagar" }
  ];
  